import React from "react";
import { Badge, IconButton } from "@mui/material";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import useShoppingCartContext from "../../context/ShoppingCart/use-shopping-cart-context";

import ShoppingCart from "../ShoppingCart";

export default function ShowShoppingCartButton({ firebase, user, uid }) {
  const { openShoppingCart, cart } = useShoppingCartContext();

  return (
    <>
      <IconButton
        edge="end"
        color="inherit"
        aria-label="cart"
        onClick={() => openShoppingCart()}
      >
        <Badge badgeContent={cart.items.length} color="primary">
          <ShoppingCartIcon fontSize="medium" sx={{ color: "primary.light" }} />
        </Badge>
      </IconButton>

      <ShoppingCart firebase={firebase} user={user} uid={uid} />
    </>
  );
}
